var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.6518 18.3708C75.6724 21.8621 76.6828 26.6466 76.6828 32.724C76.6828 38.6722 75.2178 44.3617 72.2878 49.7928C69.3578 55.0943 65.5692 59.6202 60.9219 63.37C51.4251 71.2577 40.6652 75.2018 28.6424 75.2018C17.0238 75.2018 8.7897 71.3872 3.9402 63.7579C1.31341 59.4907 0 54.4479 0 48.6289C0 37.1204 4.59694 26.9053 13.7908 17.983C22.9845 9.06074 33.9464 4.59961 46.6766 4.59961C59.5075 4.59961 68.499 9.19002 73.6518 18.3708Z",
    fill: "#FFC8B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.868 7.10051C35.7157 7.10051 30.7283 11.869 30.7283 17.7513C30.7283 23.6336 35.7157 28.4021 41.868 28.4021C48.0201 28.4021 53.0075 23.6336 53.0075 17.7513C53.0075 11.869 48.0201 7.10051 41.868 7.10051ZM23.3019 17.7513C23.3019 7.94752 31.6141 0 41.868 0C52.1217 0 60.4339 7.94752 60.4339 17.7513C60.4339 27.555 52.1217 35.5026 41.868 35.5026C31.6141 35.5026 23.3019 27.555 23.3019 17.7513ZM4.73584 74.5554C4.73584 54.948 21.3604 39.0528 41.868 39.0528C62.3754 39.0528 79 54.948 79 74.5554C79 76.5161 77.3376 78.1056 75.2867 78.1056C73.236 78.1056 71.5736 76.5161 71.5736 74.5554C71.5736 58.8694 58.2738 46.1533 41.868 46.1533C25.462 46.1533 12.1622 58.8694 12.1622 74.5554C12.1622 76.5161 10.4998 78.1056 8.44904 78.1056C6.3983 78.1056 4.73584 76.5161 4.73584 74.5554Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentIcon);
export default __webpack_public_path__ + "static/media/TalentIcon.beb31c1bfe91a54e8c17a6d336db9d05.svg";
export { ForwardRef as ReactComponent };